package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.SeparatorDemo

@Page
@Composable
fun SeparatorPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/separator.md", mapOf("title" to listOf("Separator"), "description" to listOf("Visually or semantically separates content."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/separator"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/separator#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h4
import react.dom.html.ReactHTML.p
import shadcn.ui.components.Separator
import web.cssom.ClassName

val SeparatorDemo = FC<Props> {
    div {
        div {
            className = ClassName("space-y-1")
            h4 {
                className = ClassName("text-sm font-medium leading-none")
                +"Radix Primitives"
            }
            p {
                className = ClassName("text-sm text-muted-foreground")
                +"An open -source UI component library ."
            }
        }
        Separator {
            className = ClassName("my-4")
        }
        div {
            className = ClassName("flex h-5 items-center space-x-4 text-sm")
            div {
                +"Blog"
            }
            Separator { orientation = "vertical" }
            div {
                +"Docs"
            }
            Separator { orientation = "vertical" }
            div {
                +"Source"
            }
        }
    }
}"""){ 
 SeparatorDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Separator
""", lang= "kotlin", highlight= "")
            CodeBlock("""Separator {}
""", lang= "kotlin", highlight= "")
        }
    }
}
